import Link from 'next/link';
import { Col } from 'antd';

import { SFCampaignPromotionItemViewModel } from '@api/index';

import {
  Container,
  DetailButton,
  TourName,
  ImageContainer,
  Summary,
} from './styled';

const Card = ({ title, href, image }: SFCampaignPromotionItemViewModel) => {
  return (
    <Link prefetch={false} href={href || ''} passHref legacyBehavior>
      <Container>
        <ImageContainer image={image} />
        <Summary gutter={15}>
          <Col xs={16}>
            <TourName>{title}</TourName>
          </Col>
          <Col xs={8}>
            <DetailButton>İncele</DetailButton>
          </Col>
        </Summary>
      </Container>
    </Link>
  );
};

export default Card;
